import { FC, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CustomButton, MobilePagination, Text } from '../../shared/uiComponents';
import { Loader } from '../../components/StyledComponents';
import MobileSort from '../../components/MobileSort';
import { AdminDataProperties } from './tableInfo';

import { getAdmins } from '../../redux/State/userSlice';
import { DispatchProperties, useSelector } from '../../redux/store';
import { sortData } from '../Users/mobileView';
import { Users } from '../../shared/Assets/menuIcons';
import { PlusIcon, SearchIcon } from '../../shared/Assets/svg';
import SearchBar from '../../components/SearchBar';
import MobileViewClientItem from '../../components/MobileViewClientItem';
import { useCheckPermission } from '../../shared/Helpers/hooks';
import { PERMISSIONS } from '../../App/constants';
import { AdminTypes } from '../../components/Menu';

const MobileView: FC<AdminDataProperties> = (data) => {
	const { query, totalNumberOfItems } = data;
	const [params] = useSearchParams();
	const loading = useSelector((state) => state.user.loading);
	const [searchOpen, setSearchOpen] = useState(false);
	const dispatch = useDispatch<DispatchProperties>();
	const navigate = useNavigate();

	const { permissionGranted } = useCheckPermission(PERMISSIONS.USER.CREATE);

	const fetchUsers = () => {
		const page = params.get('page') || '1';
		const pageSize = params.get('pageSize') || '8';
		const orderBy = params.get('orderBy') || '';
		const direction = params.get('direction') || '';
		const searchString = params.get('search') || '';
		const section = params.get('status');

		dispatch(getAdmins({ page, pageSize, orderBy, direction, searchString, section }));
	};

	const addAdminHandler = () => {
		window.localStorage.setItem('formType', AdminTypes[0]);
		navigate('/admin/new');
	};

	return (
		<div className="mobileViewClientsContainer">
			<div className="mobileViewClientsContainerHeader">
				<div className="mobileViewClientsContainerTitle">
					<div className="mobileViewClientsContainerTitleIcon">
						<Users />
					</div>
					<Text title="Admins" type="pmd" fontWeight="semiBold" />
				</div>
				<div className="mobileViewClientsContainerActions">
					<CustomButton
						buttonType="secondaryGray"
						iconOnly={<SearchIcon size={20} />}
						onClick={() => setSearchOpen((v) => !v)}
					/>
					{permissionGranted && <CustomButton title="Add Admin" iconOnly={<PlusIcon />} onClick={addAdminHandler} />}
				</div>
			</div>
			<div className={`mobileViewClientsContainerSearchExpander ${searchOpen ? 'open' : ''}`}>
				<SearchBar style={{ marginTop: 8 }} />
			</div>
			<MobileSort data={sortData} />
			{loading && <Loader />}
			{!loading && !totalNumberOfItems && (
				<div className="mobileViewClientsContainer">
					<Text title="No results" type="plg" fontWeight="semiBold" className="marginAuto" />
				</div>
			)}
			{!loading && query?.map((item) => <MobileViewClientItem data={item} fetchUsers={fetchUsers} key={item.id} />)}
			<MobilePagination data={data} />
		</div>
	);
};

export default MobileView;
